<template>
	<div v-observe-visibility="redraw">
		<div>Colonnes de sélection</div>
		<div v-for="(element, idx) in columns_select" :key="idx">
			<div class="input-group">
				<span class="input-group-text">{{ dataset_1_name }}</span>
				<b-form-input
					@change="change($event, idx, 1)"
					:list="idx + '-column_1_' + id"
					v-model="element.column_1"></b-form-input>
				<datalist :id="idx + '-column_1_' + id">
					<option></option>
					<option v-for="item in columns_1" :key="item">
						{{ item }}
					</option>
				</datalist>
				<b-button
					:variant="
						element.options1.casse == false ||
						element.options1.function
							? 'success'
							: ''
					"
					v-b-modal="'modal1_' + id + idx"
					><i class="fas fa-tools"></i
				></b-button>
				<b-modal
					:hide-footer="true"
					size="lg"
					:id="'modal1_' + id + idx"
					:title="'Options pour la colonne ' + element.column_1">
					<b-form-checkbox v-model="element.options1.casse"
						>respecter la casse</b-form-checkbox
					>
					<p>Fonction</p>
					<b-form-input
						v-model="element.options1.function"></b-form-input>
				</b-modal>
				<span class="input-group-text">{{ dataset_2_name }}</span>
				<b-form-input
					@change="change($event, idx, 2)"
					:list="idx + '-column_2_' + id"
					v-model="element.column_2"></b-form-input>
				<datalist :id="idx + '-column_2_' + id">
					<option></option>
					<option v-for="item in columns_2" :key="item">
						{{ item }}
					</option>
				</datalist>
				<b-button
					:variant="
						element.options2.casse == false ||
						element.options2.function
							? 'success'
							: ''
					"
					v-b-modal="'modal2_' + id + idx"
					><i class="fas fa-tools"></i
				></b-button>
				<b-modal
					:hide-footer="true"
					size="lg"
					:id="'modal2_' + id + idx"
					:title="'Options pour la colonne ' + element.column_2">
					<b-form-checkbox v-model="element.options2.casse"
						>respecter la casse</b-form-checkbox
					>
					<p>Fonction</p>
					<b-form-input
						v-model="element.options2.function"></b-form-input>
				</b-modal>
				<b-button variant="danger" @click="delete_columns(idx)"
					><i class="fas fa-trash"></i
				></b-button>
			</div>
		</div>
		<br />
		<b-button variant="primary" @click="add">Ajouter colonne</b-button>
		<br />
		<br />
		<b-button variant="success" @click="analyse">Analyser</b-button>
		<br />
		<br />
		<div>Colonnes à afficher</div>
		<b-form-select
			v-model="columns_print"
			:options="columns_options"
			:select-size="10"
			multiple></b-form-select>
		<br />
		<div>Sélection</div>
		<b-form-select
			v-model="select"
			:options="option_select"
			@change="print"></b-form-select>
		<div>Dataset à afficher</div>
		<b-form-select
			v-model="dataset_print"
			:options="option_print"
			@change="print()"></b-form-select>
		<b-form-checkbox
			v-model="doublons"
			@change="change_column($event, 'doublons')"
			>liste</b-form-checkbox
		>
		<b-form-checkbox
			v-model="color"
			@change="change_column($event, 'color')"
			>colorer différences</b-form-checkbox
		>
		<b-form-checkbox
			v-model="only_difference"
			@change="change_difference($event, 'only_difference')"
			>afficher que les différences</b-form-checkbox
		>
		<b-form-checkbox
			v-model="line_by_line"
			@change="analyse($event, 'line_by_line')"
			>Ligne par ligne</b-form-checkbox
		>
		<b-form-checkbox
			v-model="line_by_line_duplicate"
			@change="analyse($event, 'line_by_line_duplicate')"
			>Ligne par ligne, seulement lignes duppliquées</b-form-checkbox
		>
		<div v-if="color || only_difference">
			<div>Colonnes de différence</div>
			<b-form-select
				v-model="columns_different"
				:options="columns_options"
				:select-size="10"
				multiple></b-form-select>
			<br />
		</div>
		<p>
			Séparateur
			<b-form-input
				v-model="fusion"
				@change="print($event, 'fusion')"></b-form-input>
		</p>

		<p v-if="wait">En cours d'annalyse</p>

		<p><span v-if="only_difference">{{ count_filters }} </span>sur {{ tabulator_data.length }} lignes</p>

		<div
			v-show="tabulator_options.columns.length > 0"
			ref="tabulator"
			class="table-striped"></div>
		<b-container>
			<b-row>
				<b-col class="form-inline">
					<b-button @click="change_difference">Recherche</b-button>
					<b-form-input v-model="search"></b-form-input>
					<br />
					<br />
				</b-col>
			</b-row>
			<b-row>
				<b-col class="form-inline">
					<b-button @click="print">Recherche (sql mode)</b-button>
					<b-form-input v-model="where"></b-form-input>
					<br />
					<br />
				</b-col>
			</b-row>
			<b-row>
				<b-col class="form-inline">
					<b-button @click="dowloadCSV"
						><i class="fas fa-file-download"></i> csv</b-button
					>
					&nbsp;
					<b-button @click="dowloadExcel"
						><i class="fas fa-file-download"></i> xlsx</b-button
					>
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>

<script>
	var clone = require("clone");

	import Tabulator from 'tabulator-tables/dist/js/tabulator.min.js';
	import alasql from "alasql";
	import uniqueId from "lodash.uniqueid";

	export default {
		name: "ensemble_analyse",
		props: {
			dataset_1_name: {
				type: String,
			},
			dataset_2_name: {
				type: String,
			},
		},
		data() {
			return {
				tabulator: null,

				dataset_1: [],
				dataset_1_origin: [],
				dataset_2: [],
				dataset_2_origin: [],
				columns: [],
				columns_options: [],
				columns_1: [],
				columns_2: [],
				columns_select: [],
				columns_print: [],
				columns_different: [],
				data: [],
				tabulator_options: {
					columns: [],
				},
				tabulator_data: [],
				dowload: true,
				select: [3],
				option_select: [
					{ value: [1], text: "seulement dataset 1" },
					{ value: [2], text: "seulement dataset 2" },
					{ value: [3], text: "dataset 1 et 2" },
					{ value: [1, 2, 3], text: "dataset 1 ou 2" },
					{ value: [1, 2], text: "dataset 1 ou 2 mais pas les deux" },
					{ value: [0], text: "dataset 1 complété avec dataset 2" },
					{ value: [-1], text: "dataset 2 complété avec dataset 1" },
				],
				option_print: [
					{ value: "0", text: "dataset 1 et 2" },
					{ value: "1", text: "dataset 1" },
					{ value: "2", text: "dataset 2" },
				],
				doublons: false,
				line_by_line: false,
				line_by_line_duplicate: false,
				fusion: "",
				status: "not_accepted",
				id: uniqueId(""),
				color: false,
				only_difference: false,
				columns_option_raw: [],
				dataset_print: 0,
				where: "",
				search: "",
				wait: false,
				count_filters: 0
			};
		},
		mounted: async function () {
			var self = this;

			//console.log("mounted")

			this.set_options();

			this.tabulator_options = {
				columns: [],
				//columnMaxWidth: 500,
				paginationSize: 10,
				pagination: "local",
				tooltips: true, //show tool tips on cells
				addRowPos: "top", //when adding a new row, add it to the top of the table
				history: true, //allow undo and redo actions on the table
				movableColumns: true, //allow column order to be changed
				resizableRows: true, //allow row order to be changed
				data: this.tabulator_data,
				nestedFieldSeparator: false,
				downloadReady: function (fileContents, blob) {
					self.tabulator_data_csv = blob;
					if (self.dowload == false) {
						if (self.resolve) self.resolve();
						return false;
					} else {
						self.dowload = false;
						return blob;
					}
				},
				dataFiltered: function (filters, rows)
				{
					self.count_filters = rows.length;
				}
			};

			// Créer l'instance Tabulator
			this.$nextTick(() => {
				if (this.$refs.tabulator) {
					this.tabulator = new Tabulator(this.$refs.tabulator, this.tabulator_options);
				}
			});
		},
		watch: {
			/*columns_select : {
            deep: true,
            handler () {
            }
        },*/
			columns_print: {
				deep: true,
				handler() {
					this.change_column();
				},
			},
			columns_different: {
				deep: true,
				handler() {
					this.change_column();
					this.change_value();
				},
			},
			tabulator_data: {
				deep: true,
				handler(newData) {
					this.$emit("update", this.tabulator_data);
					if (this.tabulator && newData) {
						this.tabulator.replaceData(newData);
					}
				},
			},
			dataset_1_name: function () {
				this.set_options();
				this.update();
			},
			dataset_2_name: function () {
				this.set_options();
				this.update();
			},
		},
		methods: {
			set_options() {
				(this.option_select = [
					{ value: [1], text: "seulement " + this.dataset_1_name },
					{ value: [2], text: "seulement " + this.dataset_2_name },
					{
						value: [3],
						text:
							this.dataset_1_name + " et " + this.dataset_2_name,
					},
					{
						value: [1, 2, 3],
						text:
							this.dataset_1_name + " ou " + this.dataset_2_name,
					},
					{
						value: [1, 2],
						text:
							this.dataset_1_name +
							" ou " +
							this.dataset_2_name +
							" mais pas les deux",
					},
					{
						value: [0],
						text:
							this.dataset_1_name +
							" complété avec " +
							this.dataset_2_name,
					},
					{
						value: [-1],
						text:
							this.dataset_2_name +
							" complété avec " +
							this.dataset_1_name,
					},
				]),
					(this.option_print = [
						{
							value: "0",
							text:
								this.dataset_1_name +
								" et " +
								this.dataset_2_name,
						},
						{ value: "1", text: this.dataset_1_name },
						{ value: "2", text: this.dataset_2_name },
					]);
			},
			save() {
				return {
					columns_select: this.columns_select,
					columns_print: this.columns_print,
					select: this.select,
					doublons: this.doublons,
					fusion: this.fusion,
					color: this.color,
					line_by_line: this.line_by_line,
					line_by_line_duplicate: this.line_by_line_duplicate,
					columns_different: this.columns_different,
					only_difference: this.only_difference,
					dataset_print: this.dataset_print,
					where: this.where,
					search: this.search,
				};
			},
			async load(data) {
				this.select = data.select;
				this.doublons = data.doublons;
				this.fusion = data.fusion;
				this.color = data.color;
				this.line_by_line = data.line_by_line || false;
				this.line_by_line_duplicate =
					data.line_by_line_duplicate || false;
				this.columns_different = data.columns_different || [];
				this.only_difference = data.only_difference;
				this.dataset_print = data.dataset_print || 0;
				this.where = data.where;
				this.search = data.search;
				this.columns_select = data.columns_select;
				this.columns_print = data.columns_print;
			},
			get_data() {
				return this.tabulator_data;
			},
			redraw: function () {
				if (this.$refs.tabulator)
				this.tabulator.redraw(true);
			},
			add_print: function () {
				this.columns_print.push({
					column_1: "",
					column_2: "",
					mapping: "",
				});
			},
			delete_print_columns: function (idx) {
				this.columns_print.splice(idx, 1);
			},
			change: function (event, id, num) {
				//console.log("change")
				//console.log(this.dataset_1)
				var column_obj = this.columns_select[id];
				if (num == 1 && this.columns_2.includes(column_obj.column_1))
					column_obj.column_2 = column_obj.column_1;
				if (num == 1) column_obj.mapping = column_obj.column_1;
				//console.log(this.dataset_1)
			},
			add: function () {
				this.columns_select.push({
					options1: { casse: true, function: "" },
					column_1: "",
					options2: { casse: true, function: "" },
					column_2: "",
					mapping: "",
				});
			},
			delete_columns: function (idx) {
				this.columns_select.splice(idx, 1);
			},
			dowloadCSV: function () {
			this.dowload = true;
			this.tabulator.download("csv", "data.csv");
			},
			dowloadExcel: function () {
			this.dowload = true;
			this.tabulator.download("xlsx", "data.xlsx");
			},
			change_difference(event = null, v) {
				//console.log("change_difference")
				document.body.style.cursor = "wait";
				this.wait = true;
				var self = this;

				if (event != null && v == "only_difference") {
					this.only_difference = event;
					if (this.line_by_line) this.change_value();
				}

				//console.log(this.tabulator_options.columns)
				//console.log(this.$refs)

				this.tabulator.clearFilter();

				self.$nextTick(function () {
					function matchAny(data, filterParams) {
						//data - the data for the row being filtered
						//filterParams - params object passed to the filter

						var match = false;

						for (var key in data) {
							if (
								typeof data[key] == "string" &&
								data[key].includes(filterParams.value)
							) {
								match = true;
							}
						}

						return match;
					}

					var clear = true;
					if (self.only_difference && !self.line_by_line) {
						self.tabulator.setFilter([
							{
								field: "contain_difference",
								type: "=",
								value: true,
							},
						]);
						clear = false;
					}
					if (self.search) {
						self.tabulator.setFilter(matchAny, { value: self.search });
						clear = false;
					}
					if (clear) self.tabulator.clearFilter();
				});

				document.body.style.cursor = "default";
				this.wait = false;

			},
			async change_value(event, v) {
				document.body.style.cursor = "wait";
				this.wait = true;
				//console.log("change_value")
				var self = this;

				if (this.where)
					this.tabulator_data = alasql(
						"SELECT * FROM ? WHERE " + this.where,
						[this.tabulator_data]
					);

				for (var i = 0; i < this.tabulator_data.length; i++) {
					var id = this.tabulator_data[i].id_ensemble;
					this.tabulator_data[i].contain_difference = false;
					var columns = this.columns_option_raw;
					columns = columns.filter(function (e) {
						return (
							e !== "id_ensemble" &&
							e !== "id_ensemble_dataset" &&
							e !== "contain_difference"
						);
					});
					for (var k = 0; k < columns.length; k++) {
						var main_data = "";
						var nb_data = 0;
						var data = [];
						var column = columns[k];
						for (var j = 0; j < self.data[id].data.length; j++) {
							if (
								(this.dataset_print == 0 ||
									this.dataset_print ==
										self.data[id].data[j]
											.id_ensemble_dataset) &&
								typeof self.data[id].data[j][column] !==
									"undefined" &&
								!data.includes(self.data[id].data[j][column])
							) {
								data.push(self.data[id].data[j][column]);
								if (self.fusion) {
									if (nb_data) main_data += self.fusion;
									if (self.data[id].data[j][column] !== "")
										main_data +=
											self.data[id].data[j][column];
								} else {
									if (
										self.data[id].data[j][column] !== "" &&
										main_data === ""
									)
										main_data =
											self.data[id].data[j][column];
								}
								nb_data++;
							}
						}
						if (
							data.length > 1 &&
							this.columns_different.includes(column)
						)
							this.tabulator_data[i].contain_difference = true;
						//console.log(column + " : " + main_data)
						this.tabulator_data[i][column] = main_data;
					}
				}
				if (this.line_by_line) {
					var new_tabulator = [];
					for (var i = 0; i < this.tabulator_data.length; i++) {
						var id = this.tabulator_data[i].id_ensemble;
						for (var j = 0; j < self.data[id].data.length; j++) {
							if (
								!this.only_difference ||
								(this.only_difference &&
									this.tabulator_data[i].contain_difference)
							) {
								if (
									!this.line_by_line_duplicate ||
									(this.line_by_line_duplicate &&
										self.data[id].data.length > 1)
								) {
									self.data[id].data[j].id_ensemble_nb = j;
									new_tabulator.push(self.data[id].data[j]);
								}
							}
						}
					}
					this.tabulator_data = new_tabulator;
				}

				this.change_difference();
			},
			async change_column(event, v) {
				document.body.style.cursor = "wait";
				this.wait = true;
				//console.log("change column")
				if (v == "doublons") this.doublons = event;
				if (v == "color") this.color = event;

				var self = this;

				var columns = [];
				var formatter = function (cell) {
					var id = cell.getRow().getData().id_ensemble;
					var data = [];
					var column = cell.getColumn().getField();
					if (self.data[id]) {
						for (var j = 0; j < self.data[id].data.length; j++) {
							if (
								typeof self.data[id].data[j][column] !==
									"undefined" &&
								!data.includes(self.data[id].data[j][column])
							) {
								data.push(self.data[id].data[j][column]);
							}
						}
					}
					if (
						data.length > 1 &&
						self.color &&
						self.columns_different.includes(column)
					)
						cell.getElement().style.backgroundColor = "#ffd452";

					return cell.getValue();
				};

				for (var i = 0; i < this.columns_print.length; i++) {
					if (!this.doublons)
						columns.push({
							title: this.columns_print[i],
							field: this.columns_print[i],
							editor: "textarea",
							formatter: formatter,
						});
					else {
						columns.push({
							title: this.columns_print[i],
							field: this.columns_print[i],
							editor: "list",
							formatter: formatter,
							editorParams: function (cell) {
								var id = cell.getRow().getData().id_ensemble;
								var data = [];
								var column = cell.getColumn().getField();
								if (self.data[id]) {
									for (
										var j = 0;
										j < self.data[id].data.length;
										j++
									) {
										if (
											typeof self.data[id].data[j][
												column
											] !== "undefined" &&
											!data.includes(
												self.data[id].data[j][column]
											)
										)
											data.push(
												self.data[id].data[j][column]
											);
									}
								}
								return { values: data };
							},
						});
					}
				}
				//console.log("change column")
				this.tabulator_options.columns = columns;

				// Mettre à jour le Tabulator existant avec les nouvelles colonnes
				if (this.tabulator) {
					this.tabulator.setColumns(columns);
				}

				this.change_difference();
			},
			async analyse(event, v) {
				document.body.style.cursor = "wait";
				this.wait = true;
				//console.log("annalyse");

				if (v == "line_by_line") this.line_by_line = event;

				if (v == "line_by_line_duplicate")
					this.line_by_line_duplicate = event;

				this.dataset_1 = clone(this.dataset_1_origin);
				this.dataset_2 = clone(this.dataset_2_origin);

				document.body.style.cursor = "wait";

				var data_analyse = {};
				for (var i = 0; i < this.dataset_1.length; i++) {
					var id = "";
					for (var j = 0; j < this.columns_select.length; j++) {
						if (i == 0) {
							if (
								!this.columns_1.includes(
									this.columns_select[j].mapping
								)
							)
								this.columns_1.push(
									this.columns_select[j].mapping
								);
						}
						if (this.columns_select[j].mapping) {
							if (
								this.dataset_1[i][
									this.columns_select[j].column_1
								]
							)
								this.dataset_1[i][
									this.columns_select[j].mapping
								] =
									this.dataset_1[i][
										this.columns_select[j].column_1
									];
							var data_obj = this.dataset_1[i];
							var data =
								this.dataset_1[i][
									this.columns_select[j].mapping
								];
							if (!this.columns_select[j].options1.casse)
								data = data.toLowerCase();
							if (this.columns_select[j].options1.function)
								data = eval(
									this.columns_select[j].options1.function
								);
							id += data;
						}
					}
					if (!data_analyse[id])
						data_analyse[id] = { dataset: 0, data: [] };
					if (
						data_analyse[id].dataset != 1 &&
						data_analyse[id].dataset != 3
					)
						data_analyse[id].dataset += 1;
					data_analyse[id].dataset_1 = i;
					this.dataset_1[i]["id_ensemble"] = id;
					this.dataset_1[i]["id_ensemble_dataset"] = "1";
					data_analyse[id].data.push(clone(this.dataset_1[i]));
				}
				for (var i = 0; i < this.dataset_2.length; i++) {
					var id = "";
					for (var j = 0; j < this.columns_select.length; j++) {
						if (i == 0) {
							if (!this.columns_2.includes(this.columns_select[j].mapping))
								this.columns_2.push(this.columns_select[j].mapping);
						}
						if (this.columns_select[j].mapping) {
							if (this.dataset_2[i][this.columns_select[j].column_2])
								this.dataset_2[i][this.columns_select[j].mapping] = this.dataset_2[i][this.columns_select[j].column_2];
							var data_obj = this.dataset_2[i];
							var data =
								this.dataset_2[i][
									this.columns_select[j].mapping
								];
							if (!this.columns_select[j].options2.casse)
								data = data.toLowerCase();
							if (this.columns_select[j].options2.function)
								data = eval(
									this.columns_select[j].options2.function
								);
							id += data;
						}
					}
					if (!data_analyse[id])
						data_analyse[id] = { dataset: 0, data: [] };
					if (
						data_analyse[id].dataset != 2 &&
						data_analyse[id].dataset != 3
					)
						data_analyse[id].dataset += 2;
					data_analyse[id].dataset_2 = i;
					this.dataset_2[i]["id_ensemble"] = id;
					this.dataset_2[i]["id_ensemble_dataset"] = "2";
					data_analyse[id].data.push(clone(this.dataset_2[i]));
				}

				this.data = data_analyse;

				this.change_column();
				this.print();
			},
			async print(event, v) {
				//console.log("print")
				document.body.style.cursor = "wait";
				this.wait = true;

				if (v == "fusion") this.fusion = event;

				if (this.select.includes(0)) {
					this.tabulator_data = [];
					for (var i = 0; i < this.dataset_1.length; i++) {
						var line = this.dataset_1[i];
						var line2 =
							this.dataset_2[
								this.data[line.id_ensemble].dataset_2
							];
						if (line2) {
							for (
								var j = 0;
								j < this.columns_print.length;
								j++
							) {
								if (!line[this.columns_print[j]])
									line[this.columns_print[j]] =
										line2[this.columns_print[j]];
							}
						}
						this.tabulator_data.push(line);
					}
				} else if (this.select.includes(-1)) {
					this.tabulator_data = [];
					for (var i = 0; i < this.dataset_2.length; i++) {
						var line = this.dataset_2[i];
						var line2 =
							this.dataset_1[
								this.data[line.id_ensemble].dataset_1
							];
						if (line2) {
							for (
								var j = 0;
								j < this.columns_print.length;
								j++
							) {
								if (!line[this.columns_print[j]])
									line[this.columns_print[j]] =
										line2[this.columns_print[j]];
							}
						}
						this.tabulator_data.push(line);
					}
				} else {
					this.tabulator_data = [];
					var keys = Object.keys(this.data);
					var _1 = false;
					if (this.select.includes(1)) _1 = true;
					var _2 = false;
					if (this.select.includes(2)) _2 = true;
					var _3 = false;
					if (this.select.includes(3)) _3 = true;
					for (var i = 0; i < keys.length; i++) {
						var line = null;
						if (_1 && this.data[keys[i]].dataset == 1)
							line = this.dataset_1[this.data[keys[i]].dataset_1];
						if (_2 && this.data[keys[i]].dataset == 2)
							line = this.dataset_2[this.data[keys[i]].dataset_2];
						if (_3 && this.data[keys[i]].dataset == 3)
							line = this.dataset_1[this.data[keys[i]].dataset_1];
						if (line) {
							this.tabulator_data.push(line);
						}
					}
				}
				this.change_value();
			},
			numberToString(data)
			{
				if (data.length == 0)
					return;

				var keys = Object.keys(data[0])
				for (var i = 0; i < data.length; i++)
				{
					for (var j = 0; j < keys.length; j++)
					{
						if (typeof data[i][keys[j]] === "number")
						{
							data[i][keys[j]] = data[i][keys[j]].toString();
						}
					}
				}
			},
			async update(dataset_id, data) {
				//console.log(data)
				if (dataset_id == "1") 
				{
					this.dataset_1_origin = clone(data);
					this.numberToString(this.dataset_1_origin);
					this.dataset_1 = clone(this.dataset_1_origin);
				} 
				else if (dataset_id == "2") 
				{
					this.dataset_2_origin = clone(data)
					this.numberToString(this.dataset_2_origin);
					this.dataset_2 = clone(this.dataset_1_origin);
				}

				this.columns = [];
				this.columns_1 = [];
				this.columns_2 = [];
				if (this.dataset_1_origin.length > 0) {
					var keys = Object.keys(this.dataset_1_origin[0]);
					for (var i = 0; i < keys.length; i++) {
						this.columns.push(keys[i]);
						this.columns_1.push(keys[i]);
					}
				}
				if (this.dataset_2_origin.length > 0) {
					var keys = Object.keys(this.dataset_2_origin[0]);
					for (var i = 0; i < keys.length; i++) {
						this.columns_2.push(keys[i]);
						if (!this.columns.includes(keys[i]))
							this.columns.push(keys[i]);
					}
				}
				this.columns_1.sort(function (a, b) {
					if (a.toLowerCase() < b.toLowerCase()) return -1;
					if (a.toLowerCase() > b.toLowerCase()) return 1;
					return 0;
				});
				this.columns_2.sort(function (a, b) {
					if (a.toLowerCase() < b.toLowerCase()) return -1;
					if (a.toLowerCase() > b.toLowerCase()) return 1;
					return 0;
				});

				if (!dataset_id) {
					var columns_print = clone(this.columns_print);
					var columns_different = clone(this.columns_different);
				}

				this.columns_options = [];
				this.columns_option_raw = [];
				var arr = [];
				for (var i = 0; i < this.columns_1.length; i++) {
					if (
						this.columns_1[i] != "contain_difference" &&
						this.columns_1[i] != "id_ensemble" &&
						this.columns_1[i] != "id_ensemble_dataset" &&
						this.columns_1[i] != "id_ensemble_nb"
					)
						arr.push({
							value: this.columns_1[i],
							text: this.columns_1[i],
						});
					this.columns_option_raw.push(this.columns_1[i]);
				}
				this.columns_options.push({
					label: this.dataset_1_name,
					options: arr,
				});
				var arr = [];
				for (var i = 0; i < this.columns_2.length; i++) {
					if (
						!this.columns_1.includes(this.columns_2[i]) &&
						this.columns_2[i] != "contain_difference" &&
						this.columns_2[i] != "id_ensemble" &&
						this.columns_2[i] != "id_ensemble_dataset" &&
						this.columns_2[i] != "id_ensemble_nb"
					)
						arr.push({
							value: this.columns_2[i],
							text: this.columns_2[i],
						});
					this.columns_option_raw.push(this.columns_2[i]);
				}
				this.columns_options.push({
					label: this.dataset_2_name + " - autres colonnes",
					options: arr,
				});
				var arr = [
					{ value: "id_ensemble", text: "id_ensemble" },
					{
						value: "id_ensemble_dataset",
						text: "id_ensemble_dataset",
					},
					{ value: "id_ensemble_nb", text: "id_ensemble_nb" },
				];
				this.columns_options.push({
					label: "colonne dataset",
					options: arr,
				});

				if (!dataset_id) {
					this.columns_print = columns_print;
					this.columns_different = columns_different;
				}

				//console.log(data)
				//console.log(this.dataset_1_origin)

				//this.analyse();
			},
		},
	};
</script>
